<template>
  <img src="../../assets/logo_d.svg" class="brand-icon" />
</template>
<script>
export default {
  props: {
    iconName: {
      type: String,
      default: 'iconNavigationBrand'
    },
    width: {
      type: [Number, String],
      default: 18
    },
    height: {
      type: [Number, String],
      default: 18
    },
    iconColor: {
      type: String,
      default: 'currentColor'
    }
  }
}
</script>
<style scoped>
svg {
  display: inline-block;
  vertical-align: baseline;
}

.brand-icon {
  height: 30px;
  margin: 10px 5px 10px 10px;
  display: block;
  object-fit: contain;
}
</style>
